export enum FilterTypeEnum {
    COUNTRY = '_country',
    REGION = '_region',
    SUBREGION = '_subregion',
    BRAND = '_brand',
    SUBBRAND = '_subbrand',
    LINE = '_line',
    FORMAT = '_format',
    SELLER = '_seller',
}